import * as React from 'react';
import { FC } from 'react';

import { getInRestaurantRewardPointCost } from 'state/loyalty/in-restaurant-redemption';

import {
  RewardItemDescriptionDetail,
  RewardItemDescriptionWrapper,
  StyledDescriptionSanityBlockRenderer,
  StyledLoyaltyPointsIcon,
} from './styled';
import { IItemDescriptionProps } from './types';
import { getDescriptionDetailText } from './utils';

export const OfferItemDescription: FC<React.PropsWithChildren<IItemDescriptionProps<'offer'>>> = ({
  entryCartDetails: { offer },
}) => <StyledDescriptionSanityBlockRenderer content={offer?.description?.localeRaw} />;

export const RewardItemDescription: FC<React.PropsWithChildren<
  IItemDescriptionProps<'reward'>
>> = ({ entryCartDetails }) => {
  const detailText = getDescriptionDetailText({
    points: getInRestaurantRewardPointCost(entryCartDetails),
  });

  return (
    <RewardItemDescriptionWrapper>
      <StyledLoyaltyPointsIcon />
      <RewardItemDescriptionDetail>{detailText}</RewardItemDescriptionDetail>
    </RewardItemDescriptionWrapper>
  );
};
